
import { Options, Vue } from "vue-class-component";
export default class ProductMain extends Vue {
}
